import detect from './detect'

let cache = {}

let root = false
let ignoreScrollResize = false

const dimension = () => {
  if (cache.dimension) return cache.dimension

  var dimension = {
    width: !root ? window.innerWidth : root.offsetWidth,
    height: !root ? window.innerHeight : root.offsetHeight
  }

  // Ignore ios resize on scroll (wheen bottom bar disappear)
  if (ignoreScrollResize &&
    detect.iphone &&
    cache.dimension &&
    cache.dimension.width === dimension.width)
    dimension.height = cache.dimension.height

  dimension.ratio = dimension.width / dimension.height

  return (cache.dimension = dimension)
}

const width = () => dimension().width
const height = () => dimension().height

const testMQ = (mq) => () => cache[mq] || (cache[mq] = window.matchMedia(mq))

const medium = testMQ('(max-width: 1024px)')
const small = testMQ('(max-width: 900px)')
const smaller = testMQ('(max-width: 740px)')

const clear = () => {
  cache = {}
}

let listeners = []

const resize = () => {
  clear()
  listeners.forEach((listener) => listener.resize && listener.resize())
}

window.addEventListener('resize', resize)

const add = (listener) => listeners.push(listener)
const remove = (listener) => (listeners = listeners.filter(item => item !== listener))

const react = (Target) => {
  const componentDidMount = Target.prototype.componentDidMount
  Target.prototype.componentDidMount = function () {
    add(this)
    componentDidMount && componentDidMount.call(this)
  }

  const componentWillUnmount = Target.prototype.componentWillUnmount
  Target.prototype.componentWillUnmount = function () {
    remove(this)
    componentWillUnmount && componentWillUnmount.call(this)
  }
}

const setRoot = r => (root = r)
const setIgnoreScrollResize = i => (ignoreScrollResize = !!i)

export default {
  dimension,
  width,
  height,
  clear,
  medium,
  small,
  smaller,
  react,
  add,
  remove,
  setRoot,
  setIgnoreScrollResize
}
